import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CustomerService } from '../../../services/customer.service';

import { RouterLinkWithLang } from '../../../directives/router-link-with-lang/router-link-with-lang.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { LoginModalComponent } from '../../login-modal/login-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'mini-account',
  templateUrl: './mini-account.component.html',
  styleUrls: ['./mini-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, RouterLinkWithLang, RouterLink],
})
export class MiniAccountComponent implements OnInit {
  protected readonly customerService = inject(CustomerService);
  private authService = inject(AuthService);
  private dialog = inject(MatDialog);

  ngOnInit(): void {
  }

  onLoginClick() {
    this.dialog.open(LoginModalComponent);
  }

  logout() {
    this.authService.logout();
  }
}
